<script setup lang="ts">
import { ref, watch } from 'vue'

const props = defineProps({
  label: {
    type: String,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  show: {
    type: Boolean,
    default: true
  },
  saving: {
    type: Boolean,
    default: false
  }
})

const saving = ref<boolean>(props.saving)
const show = ref<boolean>(props.show)
const disabled = ref<boolean>(props.disabled)
const label = ref<string>(props.label)
const emit = defineEmits(['clicked'])

function button_ClickedEvent(){
	emit('clicked')
}

watch(() => props.saving, (newValue: boolean) => {
  saving.value = newValue
})
watch(() => props.show, (newValue: boolean) => {
  show.value = newValue
})
watch(() => props.disabled, (newValue: boolean) => {
  disabled.value = newValue
})
watch(() => props.label, (newValue: string) => {
  label.value = newValue
})
</script>

<template>
    
    <button v-if="show"
        type="submit"
        class="flex w-full justify-center rounded-md bg-blue-400 px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary disabled:opacity-20"
        :class="{ 'opacity-20 pointer-events-none': disabled }"
        @click="button_ClickedEvent()" 
        :disabled="saving">
        {{ label }}
    </button>
</template>